import React from "react"
import tw, { styled } from "twin.macro"
import { motion } from "framer-motion"

import IconRightArrow from "images/icons/right-arrow.inline.svg"

const Style = styled.div`
  .main {
    display: flex;
    height: 28px;
    overflow: visible;
    @media (max-width: 640px) {
      padding-left: 26px;
    }
  }

  .frame {
    ${tw`flex font-display`}
    border: 1px solid rgba(0,0,0,0);
    border-radius: 2px;
    padding: 3px;
    margin-bottom: 4px;
    margin-left: 7px;
    position: relative;
    top: 0px;
  }

  .caption {
    font-size: 8px;
    line-height: 8px;
    margin-bottom: -1px;
    opacity: 0;
    color: #ffffff;
  }

  .arrow {
    margin-left: 5px;
    svg {
      height: 100%;
      width: 100%;
    }
  }

  &.product {
    .main {
      height: 6px;
    }
  }
`

const MoreLink = ({ children, product }) => {
  return (
    <Style className={product ? "product" : ""}>
      <motion.div
        whileHover="hover"
        initial="init"
        transition={{ ease: "easeOut", duration: 0.1 }}
        className="main"
      >
        {children}
        <motion.div
          variants={{
            init: {
              left: -10,
              height: product ? 12 : 24,
              width: 26,
              padding: product ? "0 3px" : "3px",
            },
            hover: {
              backgroundColor: "#191919",
              borderColor: "#ffee62",
              left: 0,
              height: product ? 12 : 14,
              width: 42,
              top: product ? 0 : 3,
              padding: "3px",
            },
          }}
          className="frame"
        >
          <motion.div
            className="caption"
            variants={{
              init: { scale: 0, width: 0 },
              hover: { opacity: 1, scale: 1, width: 25 },
            }}
          >
            MORE
          </motion.div>
          <motion.div
            className="arrow"
            variants={{
              init: { height: product ? 10 : 13 },
              hover: { height: 6, width: 6 },
            }}
          >
            <IconRightArrow />
          </motion.div>
        </motion.div>
      </motion.div>
    </Style>
  )
}

export default MoreLink
